var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgByReceiver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9971 5.09991L16 10.6785V10.9232C16 13.6107 14.3709 15.1998 11.6138 15.1998H4.38685C1.62915 15.1998 0 13.6107 0 10.9232V5.07009C0 2.3827 1.62915 0.799805 4.38685 0.799805H11.611C14.368 0.799805 15.9971 2.3827 15.9971 5.07009V5.09991Z",
    fill: "#1080FF",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3788 5.73987C10.3788 7.14963 9.24884 8.28003 7.8386 8.28003C6.42884 8.28003 5.29844 7.14963 5.29844 5.73987C5.29844 4.33011 6.42884 3.19971 7.8386 3.19971C9.24884 3.19971 10.3788 4.33011 10.3788 5.73987ZM4 11.1556C4 9.85003 5.76832 9.52363 7.83856 9.52363C9.92032 9.52363 11.6771 9.86155 11.6771 11.1676C11.6771 12.4737 9.9088 12.7996 7.83856 12.7996C5.75728 12.7996 4 12.4617 4 11.1556Z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgByReceiver);
export default __webpack_public_path__ + "static/media/by_receiver.6cc28aec.svg";
export { ForwardRef as ReactComponent };